import React from 'react'

const RefreshIcon = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : 24}
         height={props.height ? props.height : 24} viewBox="0 0 24 24" fill="none" stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
         className="lucide lucide-refresh-ccw-icon lucide-refresh-ccw">
        <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
        <path d="M3 3v5h5"/>
        <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/>
        <path d="M16 16h5v5"/>
    </svg>
)

export default RefreshIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/RefreshIcon.jsx